import { useState } from "react";
import client, { apiError } from "../../api/client";
import { toast } from "sonner";
import { X, Loader2 } from "lucide-react";

const inputCls = "w-full h-9 px-3 rounded-md border border-input bg-background text-sm outline-none focus:ring-2 focus:ring-ring/20";
const EMPTY = { username: "", email: "", name: "", phone: "", password: "", active: true, color: "#2563eb" };

export default function LectorFormModal({ lector, onClose, onSaved }) {
  const isEdit = !!lector?.id;
  const [form, setForm] = useState(isEdit ? { ...EMPTY, ...lector, password: "" } : EMPTY);
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.name || !form.email) return toast.error("Vyplňte jméno a e-mail");
    setSaving(true);
    try {
      if (isEdit) {
        const payload = { name: form.name, email: form.email, phone: form.phone, active: form.active, color: form.color };
        if (form.password) payload.password = form.password;
        await client.put(`/admin/users/${lector.id}`, payload);
      } else {
        if (!form.username || !form.password) { setSaving(false); return toast.error("Vyplňte přihlašovací jméno a heslo"); }
        await client.post("/admin/users", { ...form, role: "lector" });
      }
      toast.success(isEdit ? "Lektor uložen" : "Lektor vytvořen");
      onSaved();
    } catch (err) { toast.error(apiError(err)); } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onMouseDown={onClose}>
      <div className="bg-background rounded-lg border border-border shadow-lg w-full max-w-md" onMouseDown={(e) => e.stopPropagation()} data-testid="lector-modal">
        <div className="flex items-center justify-between px-5 h-14 border-b border-border">
          <h3 className="font-heading font-semibold">{isEdit ? "Upravit lektora" : "Nový lektor"}</h3>
          <button onClick={onClose}><X className="h-5 w-5 text-muted-foreground" /></button>
        </div>
        <div className="p-5 space-y-3">
          <div><label className="text-xs text-muted-foreground">Jméno</label><input value={form.name} onChange={(e) => set("name", e.target.value)} className={inputCls} data-testid="lector-name" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="text-xs text-muted-foreground">Přihlašovací jméno</label><input value={form.username} onChange={(e) => set("username", e.target.value)} disabled={isEdit} className={inputCls + (isEdit ? " opacity-60" : "")} data-testid="lector-username" /></div>
            <div><label className="text-xs text-muted-foreground">E-mail</label><input value={form.email} onChange={(e) => set("email", e.target.value)} className={inputCls} data-testid="lector-email" /></div>
          </div>
          <div><label className="text-xs text-muted-foreground">Telefon</label><input value={form.phone || ""} onChange={(e) => set("phone", e.target.value)} className={inputCls} /></div>
          <div className="flex items-center gap-3">
            <div><label className="text-xs text-muted-foreground block mb-1">Barva v kalendáři</label><input type="color" value={form.color || "#2563eb"} onChange={(e) => set("color", e.target.value)} className="h-9 w-16 rounded-md border border-input" data-testid="lector-color" /></div>
            <span className="text-xs text-muted-foreground">Podle této barvy se lektor zobrazí v kalendáři (pro odhalení konfliktů).</span>
          </div>
          <div><label className="text-xs text-muted-foreground">Heslo {isEdit && "(ponechte prázdné pro zachování)"}</label><input type="password" value={form.password} onChange={(e) => set("password", e.target.value)} className={inputCls} data-testid="lector-password" /></div>
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.active} onChange={(e) => set("active", e.target.checked)} /> Aktivní účet</label>
        </div>
        <div className="px-5 py-4 border-t border-border flex justify-end gap-2">
          <button onClick={onClose} className="h-9 px-4 rounded-md border border-border text-sm hover:bg-secondary">Zrušit</button>
          <button onClick={save} disabled={saving} data-testid="lector-save" className="h-9 px-4 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 disabled:opacity-60 flex items-center gap-2">{saving && <Loader2 className="h-4 w-4 animate-spin" />} Uložit</button>
        </div>
      </div>
    </div>
  );
}
